module.exports = __webpack_public_path__ + "static/media/norsar-logo.7dec37b8.png";